import { Popover, PopoverContent, PopoverHandler, Tooltip } from '@material-tailwind/react'
import React, { useEffect, useState } from 'react'
import { BiLeftArrowAlt, BiPlus, BiRightArrowAlt } from 'react-icons/bi'
import { IoChevronDownOutline, IoChevronUpOutline, IoClose } from 'react-icons/io5'
import { InfoIcon2 } from '../../Assets/AllSvg'
import { BsArrowUpShort } from 'react-icons/bs'
import { IoMdAdd } from 'react-icons/io'
import PriceInfo from './PriceInfo'
import AWS from 'aws-sdk';
import { toast } from 'react-toastify'

const S3_BUCKET = process.env.REACT_APP_IMAGE_S3_BUCKET;
const APP_ACCESS_KEY = process.env.REACT_APP_ACCESS_KEY;
const APP_SCRET_KEY = process.env.REACT_APP_SCRET_KEY;

AWS.config.update({
    accessKeyId: APP_ACCESS_KEY,
    secretAccessKey: APP_SCRET_KEY,
})

const ProductInfo = ({ formData, setFormData, ID, setUploadFile, file, setFile, priceDetails, setPriceDetails, objectKey }) => {
    const [popOver, setPopOver] = useState(false)
    const [options, setOptions] = useState(false)
    const [value, setValue] = useState({
        tab: 'recurring',
        usage: false,
        option: false,
        addTrial: false,
        addCur: false,
    })
    const [tooltipNum, setTooltipNum] = useState({
        name: 1,
        price: 1,
    })
    const [metaDataList, setMetaDataList] = useState([])
    const [fetaureList, setFetaureList] = useState([])

    const triggers = {
        onMouseEnter: () => setPopOver(true),
        onMouseLeave: () => setPopOver(false),
    };

    const handleChange = (e) => {
        setFile(URL.createObjectURL(e.target.files[0]));
        setUploadFile(e.target.files[0])
    }

    const handleMetaData = () => {
        setMetaDataList([...metaDataList, { key: '', value: '' }])
    }

    const handleDeleteMetaData = (i) => {
        setMetaDataList(metaDataList.filter((val, ind) => ind !== i))
    }

    const handleOnchangeKey = (e, i) => {
        setFormData({ ...formData, metadata: e.target.value })
        const data = metaDataList.map((value, index) => {
            if (index === i) {
                value.key = e.target.value
            }
            return value
        })
        setMetaDataList(data)
    }

    const handleOnchangeValue = (e, i) => {
        setFormData({ ...formData, metadata: e.target.value })
        const data = metaDataList.map((value, index) => {
            if (index === i) {
                value.value = e.target.value
            }
            return value
        })
        setMetaDataList(data)
    }

    const handleFeature = () => {
        setFetaureList([...fetaureList, { value: '' }])
    }

    const handleDeleteFeatureList = (i) => {
        setFetaureList(fetaureList.filter((val, ind) => ind !== i))
    }

    const handleOnchangeFtrValue = (e, i) => {
        setFormData({ ...formData, feature_list: e.target.value })
        const data = fetaureList.map((value, index) => {
            if (index === i) {
                value.value = e.target.value
            }
            return value
        })
        setFetaureList(data)
    }

    const handleAddPrice = async () => {
        setPriceDetails([...priceDetails, {
            select_currency : 'USD',
            price_data : '',
            isOpen: true,
            pricing_model: 'Standard pricing'
        }])
    }

    const handleDeleteUploadFile = () => {
        setFile('');
        setUploadFile('')

        if(objectKey !== ''){
            const s3 = new AWS.S3();
            const paramsDelete = {
                Bucket: S3_BUCKET,
                Key: objectKey
            };
            
            s3.deleteObject(paramsDelete, (error, data) => {
              if (error) {
                toast.error(error, { autoClose: 5000 });
              }
            });
        }
    }

    useEffect(() => {
        if (ID !== "") {
            setOptions(true);
        }
    }, []);

    return (
        <div>
            <div className="sm:p-[40px] p-[20px]">
                <div className="max-w-[845px] w-full mx-auto ">
                    <div className='max-w-[480px] w-full'>
                        <span className="text-[20px] text-[#1a1b25] font-bold">Product information</span>
                        <div className='sm:mt-10 mt-5'>
                            <span className="text-sm text-[#414552] font-bold">Product details</span>
                            <div className='sm:mt-8 mt-4 flex xs:flex-row flex-col gap-[22px]'>
                                <div className='w-full'>
                                    <div className='w-full'>
                                        <div className='flex gap-2 items-center'>
                                            <span className='text-sm text-[#414552] font-medium'>Name</span>
                                            <Popover open={popOver} placement='right-start' handler={setPopOver}>
                                                <PopoverHandler {...triggers}>
                                                    <button><InfoIcon2 /></button>
                                                </PopoverHandler>
                                                <PopoverContent {...triggers} className="z-[999] ml-2 -mt-2 p-0 rounded-md border-0 border-t-[2px] border-[#625afa] max-w-[300px] bg-white w-full text-[#1a1b25] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.35)]">
                                                    <div className='p-[12px_16px]'>
                                                        <div className="flex items-center justify-between">
                                                            <span className='text-sm font-semibold'>
                                                                {tooltipNum.name === 1 && "What's a product?"}
                                                                {tooltipNum.name === 2 && "Simple subscriptions"}
                                                                {tooltipNum.name === 3 && "Varying subscriptions"}
                                                                {tooltipNum.name === 4 && "Physical goods"}
                                                                {tooltipNum.name === 5 && "Still have questions?"}
                                                            </span>
                                                            <div className='flex'>
                                                                <button onClick={() => setTooltipNum({ ...tooltipNum, name: tooltipNum.name - 1 })} disabled={tooltipNum.name === 1 ? true : false}>
                                                                    <BiLeftArrowAlt className={`${tooltipNum.name === 1 ?
                                                                        "text-gray-500" : "text-[#625afa]"} text-[20px]`} />
                                                                </button>
                                                                <button onClick={() => setTooltipNum({ ...tooltipNum, name: tooltipNum.name + 1 })} disabled={tooltipNum.name === 5 ? true : false}>
                                                                    <BiRightArrowAlt className={`${tooltipNum.name === 5 ?
                                                                        "text-gray-500" : "text-[#625afa]"} text-[20px]`} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <p className='text-[#414552] mt-2'>
                                                            {tooltipNum.name === 1 &&
                                                                'Products are the goods or services you sell. If you sell subscriptions, you might call them "plans." Product names are visible to customers at checkout, in receipts, invoices, and the customer portal.'
                                                            }
                                                            {tooltipNum.name === 2 &&
                                                                'A video streaming service offers a monthly subscription. In Stripe, this would be a product with one price.'
                                                            }
                                                            {tooltipNum.name === 3 &&
                                                                "A productivity tool sells three plans with monthly or annual subscriptions. In Stripe, each plan becomes a product with two prices."
                                                            }
                                                            {tooltipNum.name === 4 &&
                                                                "A fashion brand sells items in the US and Canada. In Stripe, each item becomes a product with two prices, in USD and CAD."
                                                            }
                                                            {tooltipNum.name === 5 &&
                                                                <div>
                                                                    <span className='text-[#625afa] font-semibold cursor-pointer'>Read the docs</span> for more examples of how to set up products and pricing.
                                                                </div>
                                                            }
                                                        </p>
                                                    </div>
                                                </PopoverContent>
                                            </Popover>
                                        </div>
                                        <input
                                            value={formData.name}
                                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                            type="text" className="mt-2 input_focus_shadow text-[#1a1b25] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none placeholder:text-[#404452] h-[30px] text-[14px]" placeholder='Premium Plan, sunglasses, etc.' />
                                    </div>
                                    <div className='mt-6 w-full'>
                                        <div className="flex gap-2 items-center">
                                            <span className="text-sm text-[#414552] font-medium">Statement descriptor</span>
                                            <Tooltip className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] p-[16px] max-w-[300px]" placement="top" content={
                                                <div className='text-sm text-[#414552]'>Product description apper at chckout, in the customer portal, and on quotes.</div>
                                            }>
                                                <button><InfoIcon2 /></button>
                                            </Tooltip>
                                            <button className="p-[1px_6px] rounded-md text-[#545969] bg-[#ebeef1] text-xs font-semibold">Optional</button>
                                        </div>
                                        <textarea
                                            value={formData.statement_descriptor}
                                            onChange={(e) => setFormData({ ...formData, statement_descriptor: e.target.value })}
                                            rows="3" className='mt-2 input_focus_shadow text-[#1a1b25] font-normal p-2 w-full bg-white rounded-[6px] focus:outline-none placeholder:text-[#404452] text-[14px]'></textarea>
                                    </div>
                                </div>
                                <div className='w-[125px]'>
                                    <div className="flex gap-2 items-center">
                                        <span className="text-sm text-[#414552] font-medium">Image</span>
                                        <Tooltip className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] p-[16px] max-w-[300px]" placement="top" content={
                                            <div className='text-sm text-[#414552]'>Upload JPEG or PNG images that is less than 2 mb.</div>
                                        }>
                                            <button><InfoIcon2 /></button>
                                        </Tooltip>
                                        <button className="p-[1px_6px] rounded-md text-[#545969] bg-[#ebeef1] text-xs font-semibold">Optional</button>
                                    </div>
                                    {file === '' ?
                                        <div className='relative h-[120px] w-[120px] mt-2 cursor-pointer group transition-all z-20'>
                                            <div className='text-[#625afa] font-semibold flex rounded-md group-hover:bg-gray-100 transition-all justify-center items-center text-xs h-full w-full border-[1px] border-dashed border-gray-400'>
                                                <BsArrowUpShort className='text-[22px]' />Upload
                                            </div>
                                            <input type="file" onChange={handleChange} accept="image/png, image/jpeg" className='absolute top-0 left-0 h-full w-full z-10 opacity-0' />
                                        </div> :
                                        <div className='h-[120px] w-[120px] relative mt-2 rounded-md cursor-pointer group transition-all z-20'>
                                            <img src={file} className='w-full h-full rounded-md' alt="upload-file" />
                                            <div className="bg-white opacity-40 absolute hidden group-hover:flex top-0 left-0 h-full w-full items-center justify-center z-10">
                                                <input type="file" onChange={handleChange} accept="image/png, image/jpeg" className='absolute top-0 left-0 h-full w-full z-10 opacity-0' />
                                                <BiPlus className='text-[20px]' />
                                            </div>
                                            <button className='absolute hidden group-hover:flex top-[-5px] right-[-5px] z-20 items-center justify-center h-[16px] w-[16px] bg-white border-[1px] border-[#ebeef1] rounded-full' onClick={handleDeleteUploadFile}>
                                                <IoClose className='text-gray-600 text-[13px]' />
                                            </button>
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='sm:my-10 my-7'>
                        <button className='flex items-center gap-1 text-[#625afa] font-semibold text-sm' onClick={() => setOptions(!options)}>
                            Additional options
                            {options ? <IoChevronUpOutline /> : <IoChevronDownOutline />}
                        </button>
                        {options &&
                            <div className='mt-8 max-w-[340px] w-full'>
                                <div className='w-full'>
                                    <div className="flex gap-2 items-center">
                                        <span className="text-sm text-[#414552] font-medium">Description</span>
                                        <Tooltip className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] p-[16px] max-w-[300px]" placement="top" content={
                                            <div className='text-sm text-[#414552]'>Adding a statement descriptor will override your account descriptor for payments made through subscriptions. If you add a statement descriptor, choose something your customers will recognize on a bank statement.</div>
                                        }>
                                            <button><InfoIcon2 /></button>
                                        </Tooltip>
                                        <button className="p-[1px_6px] rounded-md text-[#545969] bg-[#ebeef1] text-xs font-semibold">Optional</button>
                                    </div>
                                    <input
                                        value={formData.description}
                                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                        type='text' className='mt-2 input_focus_shadow text-[#1a1b25] font-normal p-2 w-full bg-white rounded-[6px] focus:outline-none placeholder:text-[#404452] text-[14px] h-[30px]' />
                                </div>
                                <div className='mt-5 w-full'>
                                    <div className="flex gap-2 items-center">
                                        <span className="text-sm text-[#414552] font-medium">Unit label</span>
                                        <Tooltip className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] p-[16px] max-w-[300px]" placement="top" content={
                                            <div className='text-sm text-[#414552]'>Adding a unit label describes how you sell your product. For example, if you charge by the seat and use "seat" as the unit label, it will be included in the line item as the price per seat. Unit labels for packaged prices should be pluralized, e.g. “seats.” Unit labels appear in customers’ receipts, invoices, Checkout, and the customer portal </div>
                                        }>
                                            <button><InfoIcon2 /></button>
                                        </Tooltip>
                                        <button className="p-[1px_6px] rounded-md text-[#545969] bg-[#ebeef1] text-xs font-semibold">Optional</button>
                                    </div>
                                    <input
                                        value={formData.unit_label}
                                        onChange={(e) => setFormData({ ...formData, unit_label: e.target.value })}
                                        type='text' className='mt-2 input_focus_shadow text-[#1a1b25] font-normal p-2 w-full bg-white rounded-[6px] focus:outline-none placeholder:text-[#404452] text-[14px] h-[30px]' />
                                </div>
                                <div className='mt-7 w-full'>
                                    <div className="flex gap-2 items-center">
                                        <span className="text-sm text-[#414552] font-medium">Metadata</span>
                                        <Tooltip className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] p-[16px] max-w-[300px]" placement="top" content={
                                            <div className='text-sm text-[#414552]'>Metadata is useful for storing additional structured information. <span className='text-[#625afa] font-semibold'>Learn more</span></div>
                                        }>
                                            <button><InfoIcon2 /></button>
                                        </Tooltip>
                                    </div>
                                    <div className='mt-2'>
                                        {metaDataList.length === 0 ?
                                            <button className='h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-1 text-[#414552]' onClick={handleMetaData}><BiPlus className="text-[20px]" />Add metadata</button>
                                            : <div>
                                                {metaDataList.map((mtData, ind) =>
                                                    <div key={ind} className="my-3">
                                                        <div className="w-full flex gap-3">
                                                            <input value={mtData.key} onChange={(e) => handleOnchangeKey(e, ind)} type="text" placeholder="Key" className="input_focus_shadow text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]" />
                                                            <input value={mtData.value} onChange={(e) => handleOnchangeValue(e, ind)} type="text" placeholder="Value" className="input_focus_shadow text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]" />
                                                            <button onClick={() => handleDeleteMetaData(ind)}>
                                                                <IoClose className='text-[18px] text-[#625afa]' />
                                                            </button>
                                                        </div>
                                                    </div>)}
                                                <button className="mt-5 text-sm font-semibold text-[#625afa] flex gap-1 items-center" onClick={handleMetaData}><BiPlus className='text-[20px]' />Add more metadata
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <div className='mt-5 w-full'>
                                    <div className="flex gap-2 items-center">
                                        <span className="text-sm text-[#414552] font-medium">Feature list</span>
                                        <Tooltip className="bg-white text-[#414552] shadow-[0px_0px_10px_1px_rgba(0,0,0,0.15)] p-[16px] max-w-[300px]" placement="top" content={
                                            <div className='text-sm text-[#414552]'>Describe different features or aspects of
                                                your product with a line by line breakdown. Enter each list item in a separate line, Feature lists are displayed in pricing tables.</div>
                                        }>
                                            <button><InfoIcon2 /></button>
                                        </Tooltip>
                                        <button className="p-[1px_6px] rounded-md text-[#545969] bg-[#ebeef1] text-xs font-semibold">Optional</button>
                                    </div>
                                    <div className='mt-2'>
                                        {fetaureList.length === 0 ?
                                            <button className='h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-1 text-[#414552]' onClick={handleFeature}><BiPlus className="text-[20px]" />Add feature</button>
                                            : <div>
                                                {fetaureList.map((ftData, ind) =>
                                                    <div className="my-3">
                                                        <div className="w-full flex gap-3">
                                                            <input value={ftData.value}
                                                                onChange={(e) => handleOnchangeFtrValue(e, ind)} type="text" className="input_focus_shadow text-[#404552] font-normal px-2 w-full bg-white rounded-[6px] focus:outline-none h-[30px] text-[14px]" />
                                                            <button onClick={() => handleDeleteFeatureList(ind)}>
                                                                <IoClose className='text-[18px] text-[#625afa]' />
                                                            </button>
                                                        </div>
                                                    </div>)}
                                                <button className="mt-5 text-sm font-semibold text-[#625afa] flex gap-1 items-center" onClick={handleFeature}><BiPlus className='text-[20px]' />Add another line
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>

                    <div className='text-[20px] sm:mb-[20px] text-[#1A1B25] font-[700]'>Price information</div>
                    {priceDetails.length >= 2 && <div className='h-[1px] w-[100%] bg-[#ebeef1]'></div>}
                    <PriceInfo
                        value={value}
                        setValue={setValue}
                        priceDetails={priceDetails}
                        setPriceDetails={setPriceDetails}
                        tooltipNum={tooltipNum}
                        setTooltipNum={setTooltipNum}
                    />
                    <div className='py-[48px]'>
                        <button onClick={handleAddPrice} className='h-[30px] rounded-[6px] input_focus_shadow text-[14px] font-semibold p-[0_8px] flex items-center gap-2 text-[#414552]'><IoMdAdd className='text-[18px]' />Add another price</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductInfo